<div class="page-container" style="min-height:188.38330078125px">
  <!--Page content -->
  <div class="page-content text-center">
    <div class="panel panel-flat shadow" style="border: none">
      <div class="panel-body">

          <div class="row">
            <h1>Giriş Yapılıyor...</h1>
          </div>

          <!-- <div class="row">
            <br>
            <strong *ngIf="!isLoggedIn; else corsErrorContainer">{{translate.instant("To upload your document, you need to be signed in. Please sign in and try again.")}}</strong>
            <ng-template #corsErrorContainer>
              <strong *ngIf="corsError; else missingParametersContainer">{{translate.instant("Document could not downloaded due to permissions. Please change the visibility options of your Google Docs document.")}}</strong>
            </ng-template>
            <ng-template  #missingParametersContainer>
              <strong *ngIf="missingParameters; else processContainer">{{translate.instant("URL is wrong or some parameters are missing, are you sure you are using our Google Docs plugin?")}}</strong>
            </ng-template >
            <ng-template #processContainer>
              <strong *ngIf="!corsError && isLoggedIn && !missingParameters">İşlem Durumu</strong> {{processState}}
            </ng-template>
            <br>
          </div>

          <div class="container-fluid" *ngIf="!corsError && isLoggedIn && !missingParameters">
            <div class="row">
              <br><br>
                <span><strong>{{cloudFile?.status == "" ? "" : translate.instant(cloudFile?.status)}}</strong></span>
              <br>
              <span>{{cloudFile?.progress }}%</span>
              <div *ngIf="cloudFile?.progress" class="progress " style="margin-bottom: 0;">
                <div 
                  class="progress-bar progress-bar-success" 
                  role="progressbar" 
                  aria-valuenow="10" 
                  aria-valuemin="0" 
                  aria-valuemax="100"
                  [ngStyle]="{ 'width': cloudFile?.progress + '%' }">
                </div>
              </div>
              <div class="col-md-3 center-block text-center">
                <br>
                <div id="box-select" class="center-block" data-link-type="direct" data-multiselect="false" data-client-id="bn2fljdgw0mn7wq5v773x3yiyvadw0gh"></div>
              </div>
            </div>
          </div> -->

      </div>
    </div>
  </div>
</div>
